<template>
    <div
    ref="modalEliminar"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    >
        <div
        class="modal-dialog modal-dialog-centered"
        :class="tamano ? tamano : ''"
        role="document"
        >
            <div class="modal-content">
                <div class="modal-header d-middle mb-1 border-bottom">
                    <div class="col f-600 f-20">
                        {{ titulo }}
                    </div>
                    <div class="ml-auto my-auto d-middle-center bg-white rounded-circle" style="width:20px;height:20px;">
                        <i class="icon-cancel-circled f-20 cr-pointer text-general" data-dismiss="modal" />
                    </div>
                </div>
                <div class="modal-body overflow-auto custom-scroll" style="max-height:70vh;">
                    <div class="row mx-0 my-3 f-14 text-center">
                        <div class="col-12 text-general f-500">
                            {{ mensaje }}
                        </div>
                        <div class="col-12 text-general mt-2">
                            {{ subMensaje }}
                        </div>
                    </div>
                    <slot />
                    <div class="row mx-0 bg-linea" />
                </div>
                <div class="row mx-0 justify-content-end pb-3">
                    <div 
                    class="bg-f5 text-86 d-middle-center cr-pointer border br-4" 
                    style="width:94px;height:32px;"
                    @click="cancelar"
                    v-text="textosBotones.cerrar"
                    >
                        Cerrar
                    </div>
                    <div 
                    class="bg-general mx-2 d-middle-center cr-pointer text-white br-4"
                    style="width:94px;height:32px;"
                    @click="actionEliminar"
                    v-text="textosBotones.eliminar"
                    >
                        Eliminar
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        titulo: {
            type: String,
            default: ''
        },
        btns: {
            type: Array,
            default: () => { return [] }
        },
        cargando: {
            type: Boolean,
            default: false
        },
        mensaje: {
            type: String,
            default: ''
        },
        subMensaje: {
            type: String,
            default: ''
        },
        tamano: {
            type: String,
            default: ''
        },
    },
    data(){
        return {
            textosBotones: {
                listo: 'Listo',
                aceptar: 'Aceptar',
                guardar: 'Guardar',
                eliminar: 'Eliminar',
                cerrar: 'Cerrar'
            }
        }
    },
    methods: {
        toggle(){
            $(this.$refs.modalEliminar).modal('toggle')
        },
        guardar(){
            this.$emit('guardar')
        },
        actionEliminar(){
            this.$emit('eliminar')
        },
        onAdicional(){
            this.$emit('adicional')
        },
        cancelar(){
            this.$emit('cancelar')
            this.toggle()
        }
    }
}
</script>

<style lang="scss" scoped>
.bg-linea{
    background: linear-gradient(to right, #fff, #D1D1D1, #fff);
    height: 1px;
}
.modal-content{
    border: none;
    border-radius: 8px;
    .modal-header{
        height: 73px;
        // background:linear-gradient( rgba(50,163,253,.65) 1% , rgba(255,255,255,1) , rgba(255,255,255,1), rgba(255,255,255,1) );
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-bottom: none;
        background-size: cover;
        .close{
            outline: none;
            transition-duration: .85s;
            position: absolute;
            right: 10px;
            top: 1px;
            font-size: 2.5em;
            &:hover{
                transition-duration: .4s;
                transform: rotate(360deg) scale(1.2);
            }
        }
        .logo{
            display: block;
            // height: 70px;
            // width: 70px;
            span{
                font-size: 1.2em;
            }
        }
    }
    .modal-title{
        color: #32a3fd;
        font-weight: normal;
    }
}
.img-tipo{
    position: absolute;
    top:20px;
    left: 50%;
    transform: translate(-50%);
}
</style>
